module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#album",
      toString: function () {
        return this.url;
      }
    }